import { render, staticRenderFns } from "./CrearProveedorModal.vue?vue&type=template&id=6ab97519&"
import script from "./CrearProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./CrearProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports